import { useEffect, useState } from 'react';

export const useRetryCountdown = () => {
  const [retryAt, setRetryAt] = useState<number | null>(null);
  const [secondsLeft, setSecondsLeft] = useState(0);

  useEffect(() => {
    if (retryAt === null) {
      setSecondsLeft(0);
      return;
    }

    const updateSecondsLeft = () => {
      const left = Math.ceil((retryAt - Date.now()) / 1000);

      if (left <= 0) {
        setRetryAt(null);
        return;
      }

      setSecondsLeft(left);
    };

    updateSecondsLeft();
    const interval = setInterval(updateSecondsLeft, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [retryAt]);

  const startCountdown = (retryAfterMs: number) => {
    setRetryAt(Date.now() + retryAfterMs);
  };

  const resetCountdown = () => {
    setRetryAt(null);
  };

  return { secondsLeft, startCountdown, resetCountdown };
};
